{
    "Profile_Residents_Resident.residentDetails": "FR: Resident Details",
    "Profile_Residents_Resident.number": "FR: Number",
    "Profile_Residents_Resident.type": "FR: Type",
    "Profile_Residents_Resident.applicant": "FR: Applicant",
    "Profile_Residents_Resident.coApplicant": "FR: Co-Applicant",
    "Profile_Residents_Resident.relationshipToApplicant": "FR: Relationship to Applicant",
    "Profile_Residents_Resident.bankruptcy": "FR: Bankruptcy",
    "Profile_Residents_Resident.yearsContinuouslyInsured": "FR: Years Continuously Insured",
    "Profile_Residents_Resident.yearsInsuredAtCurrentAddress": "FR: Years Insured at Current Address",
    "Profile_Residents_Resident.yearsAtCurrentAddress": "FR: Years At Current Address",
    "Profile_Residents_Resident.numberOfLosses": "FR: Number of Losses",
    "Profile_Residents_Resident.numberOfYearsForLosses": "FR: Number of Years for Losses",
    "Profile_Residents_Resident.lossWithin3Years": "FR: Loss Within 3 Years",
    "Profile_Residents_Resident.previousAddressDetails": "FR: Previous Address Details",
    "Profile_Residents_Resident.locationDetails": "FR: Location Details",
    "Profile_Residents_Resident.name": "FR: Name",
    "Profile_Residents_Resident.person": "FR: Person",
    "Profile_Residents_Resident.criminalConvictions": "FR: Criminal Convictions",
    "Profile_Residents_Resident.claims": "FR: Claims",
    "Profile_Residents_Resident.cancellations": "FR: Cancellations",
    "Profile_Residents_Resident.newCriminalConviction": "FR: New Criminal Conviction",
    "Profile_Residents_Resident.newClaim": "FR: New Claim",
    "Profile_Residents_Resident.newCancellationReason": "FR: New Cancellation Reason",
    "Profile_Residents_Resident.resident": "FR: Resident {number}"
}
